import CostFieldProto from "./cost-proto";

export default class CostExternalField extends CostFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.COST_EXTERNAL;
        this.formulaCompatible = true;
    }

    static getValue(item) {
        return item.costExternal
    }

    get sortHintMessage() {
        return 'Sort by Cost, Service';
    }

    getCsvValue(item) {
        return CostExternalField.getValue(item);
    }

    getValue(item) {return CostExternalField.getValue(item)}

    getFormulaValue(item) {
        let res;
        switch (this.getValueType()) {
            case gd.const.fields.valueType.FLOAT:
                res = this.getValue(item) || item.calculatedCostExternal
                break
        }
        return res
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => CostExternalField.getValue(i.item) || 0],
            directions: [sort]
        }
    }
}